$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');
  if (p === 'organizer_promo_code_product' && a === 'list') {
    $('select[name=product_id]').select2({
      theme: 'bootstrap4',
    });
  }
});
